import { DSAlert, DSButton, DSModal } from '@vr/ds-react'

const ModalSuccess = ({
  children,
  isOpen,
  onClose = () => {},
  title
}: {
  children?: React.ReactNode
  isOpen: boolean
  onClose?: () => void
  title?: string
}) => {
  return (
    <DSModal config={{ show: isOpen, onClose }}>
      <DSModal.Body>
        <DSAlert type='success' hiddenBtnClose title={title}>
          {children}
        </DSAlert>
      </DSModal.Body>
      <DSModal.Footer css={{ display: 'flex', justifyContent: 'center' }}>
        <DSButton onClick={onClose} variant='secondary'>
          Fechar
        </DSButton>
      </DSModal.Footer>
    </DSModal>
  )
}

export default ModalSuccess
